import { render, staticRenderFns } from "./SpecimensManagement.vue?vue&type=template&id=716d8770&scoped=true"
import script from "./SpecimensManagement.vue?vue&type=script&lang=js"
export * from "./SpecimensManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716d8770",
  null
  
)

export default component.exports